module.exports = __webpack_public_path__ + "static/9de24214.banner.png";